import React, { useEffect, useState, useRef, Fragment } from "react";
import "./TrainerTable.scss";
import sizeMe from "react-sizeme";

import { AspectRatio, nFormatter } from "../../../api/ReplayVariables";
import TrainerPlayer from "./TrainerPlayer";
import PlayerWindowPositions from "../../../api/PlayerWindowPositions";
import { getRepositionedSeat } from "../../../api/ReplayPlayer";
import DealerLabel from "../../../replayer/DealerLabel";
import { getTrainerSeatName } from "./TrainerVariables";

function TrainerTable({
  size,
  match,
  data,
  table,
  onRealTableRatio = () => {}
}) {
  const tableRef = useRef();

  const [vilainPositions, setVilainPositions] = useState([]);
  const [buttonSeat, setButtonSeat] = useState(0);
  const [buttonPosition, setButtonPosition] = useState({
    position: { seat: 0, top: 0, left: 0 }
  });

  const [heroPosition, setHeroPosition] = useState({
    seat: 0,
    top: 0,
    left: 0
  });
  const [realTableRatio, setRealTableRatio] = useState(1);
  const [cardsSize, setCardsSize] = useState({
    width: 0,
    height: 0,
    quarterWidth: 0
  });
  const [inited, setInited] = useState(false);

  useEffect(() => {
    let imgPosition = tableRef.current.getBoundingClientRect();
    if (!imgPosition.x) {
      imgPosition.x = imgPosition.left;
    }
    if (!imgPosition.y) {
      imgPosition.y = imgPosition.top;
    }
    //console.log("img position", imgPosition);
    //console.log("zone position", size);
    let _realTableRatio = Math.round(
      (imgPosition.width * 100) / AspectRatio.refWidth
    );
    if (realTableRatio * 100 !== _realTableRatio) {
      setRealTableRatio(_realTableRatio / 100);
      onRealTableRatio(_realTableRatio / 100);
    }
    //console.log("realTableRatio", realTableRatio);
    //----------
    //cards size
    //-----------
    {
      const cardWidth = Math.round(
        AspectRatio.refCardHalfWidth * realTableRatio
      );
      const cardHeight = Math.round(
        AspectRatio.refCardHalfWidth *
          AspectRatio.refCardHalfHeightRatio *
          realTableRatio
      );
      const cardQuarterWidth = Math.round(
        AspectRatio.refCardQuarterWidth * realTableRatio
      );
      setCardsSize({
        width: cardWidth,
        height: cardHeight,
        quarterWidth: cardQuarterWidth
      });
    }
    if (data && data.trainerResult) {
      let nbSeats = data.trainerResult.player;
      let heroSeat = nbSeats === "3" ? 2 : 3;
      //console.log("players/heroSeat", nbSeats + "/" + heroSeat);
      //---------------
      //hero position
      //---------------
      {
        let top = Math.round(
          imgPosition.y -
            size.position.top +
            PlayerWindowPositions[
              nbSeats + "_" + getRepositionedSeat(heroSeat, nbSeats) + "_top"
            ] *
              realTableRatio
        );
        let left = Math.round(
          imgPosition.x -
            size.position.left +
            PlayerWindowPositions[
              nbSeats + "_" + getRepositionedSeat(heroSeat, nbSeats) + "_left"
            ] *
              realTableRatio
        );
        setHeroPosition({ seat: heroSeat, top: top, left: left });
        if (data.trainerResult.heroPos === "BU") {
          //---------
          //BUTTON
          //---------
          let _buttonSeat = getRepositionedSeat(heroSeat, nbSeats);
          setButtonSeat((s) => _buttonSeat);
          //console.log("button:" + _buttonSeat);
          const buttonTop = Math.round(
            imgPosition.y -
              size.position.top +
              PlayerWindowPositions[
                nbSeats + "_" + _buttonSeat + "_buttonTop"
              ] *
                realTableRatio
          );
          const buttonLeft = Math.round(
            imgPosition.x -
              size.position.left +
              PlayerWindowPositions[
                nbSeats + "_" + _buttonSeat + "_buttonLeft"
              ] *
                realTableRatio
          );
          let _position = { top: buttonTop, left: buttonLeft };
          setButtonPosition((b) => _position);
        }
      }
      //------------------
      //vilain positions
      //------------------
      let _vilainPositions = [];
      for (let k = 1; k < nbSeats; k++) {
        let seat = heroSeat + k;
        let top = Math.round(
          imgPosition.y -
            size.position.top +
            PlayerWindowPositions[
              nbSeats + "_" + getRepositionedSeat(seat, nbSeats) + "_top"
            ] *
              realTableRatio
        );
        let left = Math.round(
          imgPosition.x -
            size.position.left +
            PlayerWindowPositions[
              nbSeats + "_" + getRepositionedSeat(seat, nbSeats) + "_left"
            ] *
              realTableRatio
        );
        _vilainPositions.push({
          position: { seat: seat, top: top, left: left }
        });
        if (
          getTrainerSeatName(
            match.params.game,
            data.trainerResult.heroPos,
            k
          ) === "BU"
        ) {
          //---------
          //BUTTON
          //---------
          let _buttonSeat = getRepositionedSeat(seat, nbSeats);
          setButtonSeat((s) => _buttonSeat);
          //console.log("button:" + _buttonSeat);
          const buttonTop = Math.round(
            imgPosition.y -
              size.position.top +
              PlayerWindowPositions[
                nbSeats + "_" + _buttonSeat + "_buttonTop"
              ] *
                realTableRatio
          );
          const buttonLeft = Math.round(
            imgPosition.x -
              size.position.left +
              PlayerWindowPositions[
                nbSeats + "_" + _buttonSeat + "_buttonLeft"
              ] *
                realTableRatio
          );
          let _position = { top: buttonTop, left: buttonLeft };
          setButtonPosition((b) => _position);
        }
        //console.log("vilain " + k, getRepositionedSeat(seat, nbSeats));
      }
      //console.log("nb vilains", _vilainPositions.length);
      setVilainPositions(_vilainPositions);

      //console.log("button position", buttonPosition);

      if (imgPosition.width > 2) {
        setInited(true);
      }
    }
    return () => {
      //console.log("trainerTable effect done", size);
    };
  }, [
    data,
    match.params.game,
    onRealTableRatio,
    realTableRatio,
    size.position.left,
    size.position.top
  ]);
  return (
    <div className={"table-container" + (inited ? " inited" : "")}>
      <img id="trainer-table" ref={tableRef} src={table} alt="" />
      {data && data.trainerResult ? (
        <>
          <DealerLabel
            seats={data.trainerResult.player}
            seat={buttonSeat}
            realTableRatio={realTableRatio}
            top={buttonPosition.top}
            left={buttonPosition.left}
          ></DealerLabel>
          <TrainerPlayer
            position={heroPosition}
            cardsSize={cardsSize}
            hero={true}
            realTableRatio={realTableRatio}
            imgPosition={tableRef.current.getBoundingClientRect()}
            zonePosition={size.position}
            match={match}
            data={data}
          ></TrainerPlayer>
          {vilainPositions.map((vilainPosition, i) => (
            <Fragment key={"f" + i}>
              <TrainerPlayer
                position={vilainPosition.position}
                cardsSize={cardsSize}
                hero={false}
                match={match}
                placeAfterHero={i + 1}
                realTableRatio={realTableRatio}
                imgPosition={tableRef.current.getBoundingClientRect()}
                zonePosition={size.position}
                data={data}
              ></TrainerPlayer>
            </Fragment>
          ))}
          {data.trainerResult.ante > 0 ? (
            <div
              className="ante"
              style={{
                fontSize:
                  Math.round(AspectRatio.refFontSize * realTableRatio * 1.2) +
                  "px"
              }}
            >
              Ante : {nFormatter(data.trainerResult.ante)} BB
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
export default sizeMe({
  monitorHeight: true,
  monitorWidth: true,
  monitorPosition: true
})(TrainerTable);
